export enum DistributionType {
  PERCENTAGE = 'percentage',
  CURRENCY = 'currency',
}
